import { ClipboardList, ShoppingBag, Store, Truck } from "lucide-react";

// Selo do tipo de entrega no card e no detalhe do pedido (25/10/2026).
// Antes só existiam "Retirada" e "Entrega": tudo que não era retirada virava
// "Entrega" com caminhãozinho — inclusive pedido de Balcão, Totem (tipo "local")
// e Comandas (tipo "comanda"). Mesa não passa por aqui (tem selo próprio).
const SELOS = {
  delivery: { label: "Entrega", Icon: Truck, cor: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400" },
  pickup: { label: "Retirada", Icon: Store, cor: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400" },
  local: { label: "No local", Icon: Store, cor: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400" },
  balcao: { label: "No local", Icon: Store, cor: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400" },
  viagem: { label: "Para viagem", Icon: ShoppingBag, cor: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400" },
  comanda: { label: "Comanda", Icon: ClipboardList, cor: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400" },
};

/** { label, Icon, cor } do tipo de entrega do pedido, ou null quando não dá pra saber. */
export function seloTipoEntrega(pedido) {
  const tipo = String(pedido?.tipoEntrega ?? pedido?.tipo_entrega ?? "").toLowerCase();
  if (SELOS[tipo]) return SELOS[tipo];
  // Pedido antigo sem tipo: só é "Entrega" se tiver endereço.
  return pedido?.endereco?.endereco ? SELOS.delivery : null;
}
